module.exports = __webpack_public_path__ + "img/1.f8af3b01.png";